<template>
    <Card>
        <template v-slot:title>{{ __('navigation.all_requests') }}</template>

        <div class="table-responsive">
            <table class="table table-hover table-vertical-center">
                <thead>
                <tr>
                    <th>{{ __('general.status') }}</th>
                    <th>{{ __('general.type') }}</th>
                    <th>{{ __('user-request.created_at') }}</th>
                    <th>{{ __('user-request.created_by') }}</th>
                    <th>{{ __('user-request.processed_by') }}</th>
                    <th class="text-right">{{ __('general.actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="userRequest in userRequests.data">
                    <td>
                        <Badge v-if="userRequest.approved === 1" type="badge-success">
                            <i class="fas fa-check"/>
                            {{ __('user-request.approved') }}
                        </Badge>
                        <Badge v-else-if="userRequest.approved === 0" type="badge-danger">
                            <i class="fas fa-times"/>
                            {{ __('user-request.rejected') }}
                        </Badge>
                        <Badge v-else-if="userRequest.approved === null" type="badge-info">
                            <i class="fas fa-hourglass"/>
                            {{ __('user-request.pending') }}
                        </Badge>
                    </td>
                    <td>
                        <div>
                            {{ userRequest.title || 'n/a' }}
                        </div>
                        <div class="text-muted">
                            {{ userRequest.request_name }}
                        </div>
                    </td>
                    <td>
                        <DateTime :timestamp="userRequest.created_at" short/>
                    </td>
                    <td>
                        {{ userRequest.user_name || 'n/a' }}
                        <div>
                            {{ userRequest.user_phone || 'n/a' }}
                        </div>
                    </td>
                    <td>
                        <div v-if="userRequest.agent_id">
                            {{ userRequest.agent_name }}
                        </div>
                        <div v-else class="text-muted">
                            -
                        </div>
                    </td>
                    <td class="text-right">
                        <div v-if="Permission.EDIT_USER_REQUESTS">
                            <div v-if="userRequest.approved === null">
                                <a v-if="userRequest.agent_id === null"
                                   class="btn btn-sm btn-primary"
                                   :href="$route('user.requests.edit', [userRequest.id])">
                                    <i class="fas fa-pen-square"/>
                                    {{ __('general.edit') }}
                                </a>
                                <a v-else
                                   class="btn btn-sm btn-default"
                                   :href="$route('user.requests.show', [userRequest.id])">
                                    <i class="fas fa-hourglass-half"/>
                                    {{ __('user-request.in_process') }}
                                </a>
                            </div>
                            <div v-else-if="userRequest.approved === 0">
                                <button class="btn btn-sm btn-light-info" @click="showReason(userRequest.reason)">
                                    <i class="fas fa-eye"/>
                                    {{ __('user-request.reason') }}
                                </button>
                            </div>
                        </div>

                        <a class="btn btn-sm btn-default"
                           :href="$route('user.requests.show',[userRequest.id])">
                            <i class="fas fa-eye"/>
                            {{ __('actions.view') }}
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <Pagination :pagination="userRequests"/>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import Badge from "@components/Badge.vue";
import DateTime from "@components/DateTime.vue";
import {PermissionsMixin} from "@js/permissions";
import Pagination from "@components/TableComponents/Pagination.vue";

export default {
    components: {Pagination, DateTime, Badge, Card},

    mixins: [PermissionsMixin],

    props: {
        userRequests: Object,
        totalRequests: Number
    },

    methods: {
        showReason(reasonText) {
            Swal.fire({
                title: __('user-request.reason'),
                html: reasonText,
            })
        }
    }
}
</script>
